import { Model, View } from '@lernetz/ts-lib';

import type { AnswerBase } from './AnswerBase';
import template from './ScoreQuizAnswer.html';

export class ScoreQuizAnswer extends Model implements AnswerBase {

    public correctlyAnswered: boolean;
    public evaluated: boolean;
    public points: number;
    public selected: boolean;
    public text: string;

    constructor(private readonly dto) {
        super({
            correctlyAnswered: true,
            evaluated: false,
            points: 0,
            selected: false,
            text: '',
            ...dto
        });
    }

    toggle() {
        if( this.evaluated ) return;
        this.selected = true;
    }
}

export class ScoreAnswerView extends View<ScoreQuizAnswer> {

    constructor() {
        super({ template });
    }
}
